export const Wordmark = ({ className = "", size = "text-2xl" }) => (
  <span className={`font-cabinet font-black tracking-tight leading-none ${size} ${className}`}>
    <span className="text-brand-ink">D</span>
    <span className="text-brand-red">D</span>
    <span className="text-brand-green">G</span>
  </span>
);

export const StampLogo = ({ size = 150, className = "" }) => (
  <div
    className={`relative ${className}`}
    style={{ width: size, height: size }}
    aria-hidden="true"
  >
    <svg viewBox="0 0 200 200" className="w-full h-full stamp-rotate">
      <defs>
        <path
          id="stamp-circle"
          d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0"
        />
      </defs>
      <circle cx="100" cy="100" r="97" fill="none" stroke="rgba(10,10,10,0.35)" strokeWidth="2.5" />
      <circle cx="100" cy="100" r="62" fill="none" stroke="rgba(10,10,10,0.35)" strokeWidth="1.5" />
      <text
        fill="rgba(10,10,10,0.55)"
        style={{ fontSize: "13.5px", letterSpacing: "3.5px", fontFamily: '"Cabinet Grotesk", sans-serif', fontWeight: 700 }}
      >
        <textPath href="#stamp-circle">
          PT DARMA DAYA GUNA • TRAINING &amp; CONSULTANT •
        </textPath>
      </text>
    </svg>
    <div className="absolute inset-0 flex items-center justify-center">
      <Wordmark size="text-3xl" />
    </div>
  </div>
);
